import { render, staticRenderFns } from "./IdDetailView.vue?vue&type=template&id=5981b155&%40lo=true&"
import script from "./IdDetailView.vue?vue&type=script&lang=js&"
export * from "./IdDetailView.vue?vue&type=script&lang=js&"
import style0 from "./IdDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports